import { render, staticRenderFns } from "./ProductHistoryReport.vue?vue&type=template&id=d5208e12&scoped=true&"
import script from "./ProductHistoryReport.vue?vue&type=script&lang=js&"
export * from "./ProductHistoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5208e12",
  null
  
)

export default component.exports